import { render } from "./ActividadFisica.vue?vue&type=template&id=0fb4a90e"
import script from "./ActividadFisica.vue?vue&type=script&lang=js"
export * from "./ActividadFisica.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__